import React from "react";
import styled from "styled-components";
import { Sheet, useTheme } from "@mui/joy";

const Hello = styled.h1`
  margin: 1% 0 1% 2%;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2.5vw" : "5vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const Headline = styled.h1`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "2vw" : "4vw")};
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  white-space: nowrap;
`;

const ImageCompanyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const CompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3%;
`;

const CompanyImage = styled.img`
  display: flex;
  width: auto;
  height: auto;
  padding-top: 2%;
  max-width: 40%;
  max-height: ${(props) => (props.size.width >= 800 ? "30vh" : "10vh")};
  margin-left: 2% auto 2% auto;
`;

const Subtitle = styled.h2`
  margin: 1% 0;
  font-weight: 400;
  font-size: ${(props) => (props.size.width >= 800 ? "1vw" : "3vw")};
  white-space: nowrap;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
`;

const JobType = styled(Subtitle)`
  border-radius: 10px;
  padding: 3%;
  background-color: ${(props) => props.theme.palette.background.level3};
  width: max-content;
  color: ${(props) => props.theme.palette.text.primary};
`;

const Description = styled.p`
  margin: 5% auto;
  padding-inline: 2%;
`;

const Education = (props) => {
  const theme = useTheme();

  var mode = localStorage.getItem("joy-mode");

  const dynamicWidth = () => {
    if (props.size.width >= 900) {
      return (props.size.width * 3) / 5;
    } else if (props.size.width >= 600) {
      return (props.size.width * 4) / 5;
    } else {
      return (props.size.width * 6) / 7;
    }
  };

  const mainContainer = {
    borderRadius: 15,
    padding: 2,
    margin: "auto",
    marginTop: 2,
    width: dynamicWidth(),
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px;",
    flexDirection: "column",
  };

  const childContainer = {
    padding: "2%",
    borderRadius: "15px",
    marginTop: "2%",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    width: "90%",
    boxShadow:
      "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
    backgroundColor: theme.palette.background.level1,
    maxHeight: "30vh",
  };

  const EduObj = (edu, keyval) => {
    var descr = [];

    edu.description.forEach((element) => {
      descr.push(<Description key={element.length}>{element}</Description>);
    });

    var image = edu.image;

    if (mode === "dark" && edu.image_dark) {
      image = edu.image_dark;
    }

    return (
      <Sheet sx={childContainer} key={keyval}>
        <ImageCompanyContainer>
          <CompanyImage src={image} size={props.size} />
          <CompanyInfo>
            <Headline size={props.size}>{edu.school}</Headline>
            <JobType size={props.size} theme={theme}>
              {edu.degree}
            </JobType>
            { props.size.width >= 800 &&
              <div>
                {descr}
              </div>
            }
          </CompanyInfo>
        </ImageCompanyContainer>
        { props.size.width < 800 &&
          <div>
            {descr}
          </div>
        }
      </Sheet>
    );
  };

  const edus = [];
  for (let i = 0; i < props.edu.education.length; i++) {
    edus.push(EduObj(props.edu.education[i], i));
  }

  return (
    <Sheet sx={mainContainer}>
      <Hello size={props.size}>Education</Hello>
      {edus}
    </Sheet>
  );
};

export default Education;
